import { Injectable, inject } from '@angular/core';
import { SearchDataService } from '@warema/shared/company-search/data-access';
import { Company } from '@warema/shared/models';
import { Observable, map } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SearchApiService {
    private readonly _searchDataService = inject(SearchDataService);

    public getSelectedCompanyAddressId(): Observable<string> {
        return this._searchDataService.selectedCompanyAddressId$;
    }

    public getSelectedCompany(): Observable<Company> {
        return this._searchDataService.selectedCompany$;
    }

    public selectCompany(companyAddressId: string): void {
        return this._searchDataService.selectCompany(companyAddressId);
    }

    public clearCompanySearchDataExceptLocationAndInstantOffer(): void {
        this._searchDataService.clearCompanySearchDataExceptLocationAndInstantOffer();
    }

    public clearCompanySearchData(): void {
        this._searchDataService.clearCompanySearchData();
    }

    public specificCompanyAutoSelected(company: Company): void {
        this._searchDataService.specificCompanyAutoSelected(company);
    }

    public getLatestSearchedAddress(): Observable<string> {
        return this._searchDataService.latestSearchedCoordinates$.pipe(map(x => x.address));
    }

    public isAtLeastOneCompanyFound(): Observable<boolean> {
        return this._searchDataService.companies$.pipe(map(x => x.length > 0));
    }

    public validateSearch(): void {
        this._searchDataService.validateSearch();
    }
}
